import RequirementsTab from './RequirementsTab';

export default RequirementsTab;
